import React from 'react'
import styles from "./spiritualwisdom.module.css";
import { useState } from "react";
import Head from 'next/head';

function index() {
  return (
    <>

    <Head>
    <title>Spiritual Wisdom: Free Trainings, Talks & Discussions | School of Our Divine Infinite Being</title>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1.0"
    ></meta>
    <meta
      name="keywords"
      content="Spiritual Wisdom, Free Spiritual Training, Esoteric Talks, Occult Discussions, Spirituality, Online Learning, School of Our Divine Infinite Being"
    ></meta>
    <meta
      property="og:title"
      content="Discover Spiritual Wisdom: A Collection of Free Trainings & Talks"
    ></meta>
    <meta property="og:type" content="website"></meta>
    <meta
      property="og:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/spiritual_wisdom_collection_og_img.webp"
    ></meta>
    <meta
      property="og:image:alt"
      content="Three cards titled 'Spiritual Wisdom' against a cosmic background, representing a collection of free online spiritual trainings and talks."
    ></meta>
    <meta
      property="og:description"
      content="Explore our collection of free trainings, talks, and discussions on a wide variety of fascinating spiritual topics. Broaden your education and discover new interests beyond our core teachings."
    ></meta>

    <meta property="og:image:width" content="1200"></meta>
    <meta property="og:image:height" content="627"></meta>
    <meta
      property="og:url"
      content="https://www.divineinfinitebeing.com/spiritual-wisdom"
    ></meta>

    <meta name="twitter:card" content="summary_large_image"></meta>
    <meta
      property="twitter:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/spiritual_wisdom_collection_og_img.webp"
    ></meta>
    <meta
      property="twitter:image:alt"
      content="Three cards titled 'Spiritual Wisdom' against a cosmic background, representing a collection of free online spiritual trainings and talks."
    ></meta>
    <meta
      name="twitter:url"
      content="https://www.divineinfinitebeing.com/spiritual-wisdom"
    ></meta>
    <meta
      name="twitter:title"
      content="Discover Spiritual Wisdom: A Collection of Free Trainings & Talks"
    ></meta>
    <meta
      name="twitter:description"
      content="Explore our collection of free trainings, talks, and discussions on a wide variety of fascinating spiritual topics. Broaden your education and discover new interests beyond our core teachings."
    ></meta>
    <link rel="canonical" href="https://www.divineinfinitebeing.com/spiritual-wisdom" />
</Head>

    <div className={styles.spiritual_wisdom_main_width}>
        <div className={styles.common_width}>
            <div className={styles.spiritual_wisdom_main_wrpr}>

              <div className={styles.spiritual_wisdom_box_main_width}>
                <div className={styles.spiritual_wisdom_box_img_sec}>
                  <div className={styles.spiritual_wisdom_box_img_sub}>
                    <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/assets/images/home-page-as-image2.jpg'></img>
                  </div>
                </div>
                <div className={styles.spiritual_wisdom_box_cont_main_sec}>
                  <div className={styles.spiritual_wisdom_box_cont_part}>
                    <h1>Spiritual Wisdom</h1>

                    <p>The following links are collections of free trainings, talks and discussions on a wide variety of topics that we find fascinating.  Here we depart from what we consider core teachings of the School of Our Divine Infinite Being to share some of our favorite videos on the world's spirituality in general.  Over the years all of us here have been influenced by so many incredible teachers and ideas.  Many of the categories below are related to subjects we teach and some are unrelated but very interesting. We hope to be able to help you narrow down quality interests for your education and enjoyment.</p>
                  </div>
                  <div className={styles.grey_button}>
                    <a>Learn More</a>
                  </div>
                </div>
              </div>

              <div className={styles.spiritual_wisdom_box_main_width}>
                <div className={styles.spiritual_wisdom_box_img_sec}>
                  <div className={styles.spiritual_wisdom_box_img_sub}>
                    <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/assets/images/home-page-as-image2.jpg'></img>
                  </div>
                </div>
                <div className={styles.spiritual_wisdom_box_cont_main_sec}>
                  <div className={styles.spiritual_wisdom_box_cont_part}>
                    <h1>Spiritual Wisdom</h1>

                    <p>The following links are collections of free trainings, talks and discussions on a wide variety of topics that we find fascinating.  Here we depart from what we consider core teachings of the School of Our Divine Infinite Being to share some of our favorite videos on the world's spirituality in general.  Over the years all of us here have been influenced by so many incredible teachers and ideas.  Many of the categories below are related to subjects we teach and some are unrelated but very interesting. We hope to be able to help you narrow down quality interests for your education and enjoyment.</p>
                  </div>
                  <div className={styles.grey_button}>
                    <a>Learn More</a>
                  </div>
                </div>
              </div>

              <div className={styles.spiritual_wisdom_box_main_width}>
                <div className={styles.spiritual_wisdom_box_img_sec}>
                  <div className={styles.spiritual_wisdom_box_img_sub}>
                    <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/assets/images/home-page-as-image2.jpg'></img>
                  </div>
                </div>
                <div className={styles.spiritual_wisdom_box_cont_main_sec}>
                  <div className={styles.spiritual_wisdom_box_cont_part}>
                    <h1>Spiritual Wisdom</h1>

                    <p>The following links are collections of free trainings, talks and discussions on a wide variety of topics that we find fascinating.  Here we depart from what we consider core teachings of the School of Our Divine Infinite Being to share some of our favorite videos on the world's spirituality in general.  Over the years all of us here have been influenced by so many incredible teachers and ideas.  Many of the categories below are related to subjects we teach and some are unrelated but very interesting. We hope to be able to help you narrow down quality interests for your education and enjoyment.</p>
                  </div>
                  <div className={styles.grey_button}>
                    <a>Learn More</a>
                  </div>
                </div>
              </div>

            </div>
        </div>
    </div>

    </>
  )
}

export default index